var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"polyline-box"},[_c('div',{ref:"line",staticStyle:{"width":"560px","height":"500px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }